module.exports = __webpack_public_path__ + "static/media/end-message.a6c01c98.svg";